import { render, staticRenderFns } from "./underlying-list.vue?vue&type=template&id=8ccdda8c&scoped=true&"
import script from "./underlying-list.vue?vue&type=script&lang=js&"
export * from "./underlying-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccdda8c",
  null
  
)

export default component.exports